import { ReactNode } from "react";
import GenericToggleComponent from "./GenericToggleComponent";
import SchoolService from "../../services/SchoolService";
import { connect } from "react-redux";

interface CognitoToggleComponentProps {
    defaultComponent: ReactNode,
    toggledComponent: ReactNode,
    studentOnly: boolean,
    role: string
}

const CognitoToggleComponent = ({ defaultComponent, toggledComponent, studentOnly, role }: CognitoToggleComponentProps) => {
    //can remove or add more conditions when we start the admin side
    if (studentOnly && role === "User") {
        return <GenericToggleComponent
            toggleReduxName={"cognito"}
            retrieveToggleValue={async () => {
                let schoolConfigItem = await SchoolService.getBetaTestToggleConfig("toggle.cognito");
                return schoolConfigItem?.value === "true";
            }}
            defaultComponent={defaultComponent}
            toggledComponent={toggledComponent}
        />
    } else {
        return defaultComponent;
    }
};

const mapStateToProps = (state: any) => {
    return {
        role: state.auth.role
    };
};

export default connect(mapStateToProps, {})(CognitoToggleComponent);

